function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5.000000, -13.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5,18.6881487 C6.41743412,19.7757884 7.56287286,17.5802868 9.64338257,18.6881487 C11.7238923,19.7960107 14.0543875,13.8046742 16.0596003,16.288442 C18.0648132,18.7722098 18.9586447,19.6199581 19.7762525,17.8990845 C20.5938604,16.1782109 21.5256878,13.0613542 22.5443962,15.4153167 C23.5631045,17.7692793 24.1409209,19.2690427 25.2757023,17.8990845 C26.4104836,16.5291264 26.1238923,14.5421915 27.7306111,15.4153167 C29.3373299,16.288442 29.0324356,14.7297429 30.52702,14.0961125 C32.0216044,13.4624821 31.8679988,16.1691896 33,16.1691896",
  id: "Path-6"
}))));

var SvgDaily = function SvgDaily(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "7px",
    viewBox: "0 0 29 7",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDaily, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/daily.3d29916a.svg";
export { ForwardRef as ReactComponent };